/**
 * Safe hotel URL helpers — encode ids in path segments so values with "/", spaces,
 * or other reserved characters do not break routing on mobile Safari / in-app browsers.
 */

export function buildHotelDetailPath(hotelId, searchParams) {
  if (hotelId == null) return '/hotels';
  const trimmed = String(hotelId).trim();
  if (!trimmed) return '/hotels';
  const idSeg = encodeURIComponent(trimmed);
  const qs =
    searchParams instanceof URLSearchParams && searchParams.toString()
      ? `?${searchParams.toString()}`
      : '';
  return `/hotel/${idSeg}${qs}`;
}

export function buildBookingPath(hotelId) {
  if (hotelId == null) return '/hotels';
  const trimmed = String(hotelId).trim();
  if (!trimmed) return '/hotels';
  return `/booking/${encodeURIComponent(trimmed)}`;
}

export function buildPaymentPath(hotelId) {
  if (hotelId == null) return '/hotels';
  const trimmed = String(hotelId).trim();
  if (!trimmed) return '/hotels';
  return `/payment/${encodeURIComponent(trimmed)}`;
}

/** Normalize :id from the URL for API calls (safe if the segment still contains escapes). */
export function normalizeHotelRouteId(rawId) {
  if (rawId == null || rawId === '') return '';
  const s = String(rawId);
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
}
